var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.46,
    height: 18.243,
    viewBox: "0 0 19.46 18.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_2_",
    "data-name": "home (2)",
    transform: "translate(0 -16.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M54.671,203.518H41.748A1.75,1.75,0,0,1,40,201.77v-9.2a.608.608,0,0,1,1.216,0v9.2a.533.533,0,0,0,.532.532H54.671a.533.533,0,0,0,.532-.532v-9.2a.608.608,0,0,1,1.216,0v9.2A1.75,1.75,0,0,1,54.671,203.518Z",
    transform: "translate(-38.479 -169.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M18.852,25.441a.606.606,0,0,1-.43-.178L10.859,17.7a1.6,1.6,0,0,0-2.258,0L1.038,25.263a.608.608,0,0,1-.86-.86l7.563-7.563a2.816,2.816,0,0,1,3.978,0L19.282,24.4a.608.608,0,0,1-.43,1.038Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M181.473,295.889h-4.865a.608.608,0,0,1-.608-.608v-5.4a1.9,1.9,0,0,1,1.9-1.9h2.281a1.9,1.9,0,0,1,1.9,1.9v5.4A.608.608,0,0,1,181.473,295.889Zm-4.257-1.216h3.649v-4.789a.685.685,0,0,0-.684-.684H177.9a.685.685,0,0,0-.684.684Z",
    transform: "translate(-169.31 -261.629)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.ba2a8563ab016617f21f2a9b738a62a4.svg";
export { ForwardRef as ReactComponent };